"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactSection = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ContactSection = (0, styled_1.default)('div') `
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: 0 -${(0, ui_theme_1.fromTheme)('spacing_medium')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
`;
//# sourceMappingURL=styles.js.map